<script setup>
    import { ref, onMounted, computed, getCurrentInstance, defineProps } from 'vue'
    import { useRouter } from 'vue-router'
    import SNB from '../../../../../layouts/nav/SNB.vue'
    import mypageUserResumeService from "../../../services/mypage/mypageUserResumeService";
    import { usePageLoadingStore } from "../../../../../stores/pageLoading";
    import _ from 'lodash'
    import UserMatchingResumeCreateModal from "../../../components/modal/mypage/UserMatchingResumeCreateModal.vue";
    import MyPageResumeModal from "../../../components/modal/mypage/MyPageResumeModal.vue";
    import MatchingResumeModal from "../../../components/modal/matching/MatchingResumeModal.vue";
    import {useMatchingUpdateStore} from "../../../stores/matching/matchingUpdateStore";
    import mypageMatchingService from "../../../services/mypage/mypageMatchingService";
    import { useAlertStore } from '../../../../../stores/alertStore';
    const { $alert, $confirm } = useAlertStore();

    const globals = getCurrentInstance().appContext.config.globalProperties;

    const { $pageListPorpId } = globals;
    const data_interests = ref(globals.$interests)
    const searchMonths = ref(globals.$searchMonths)

    const router = useRouter()
    const loadingStore = usePageLoadingStore()
    const matchingUpdateStore = useMatchingUpdateStore()

    const interestGbListRef = ref(null)
    const list = ref([]);
    const currentPage = ref(1);
    const pageSize = 10;
    const totalPages = ref(1);
    const totalCount = ref(0);
    const matchingResumeModal = ref(null);

    const snbKey = ref(0);

    const searchOpen = ref(true)
    const _searchInput = ref({
        searchMonthType: '0',
        searchInterests: '',
        searchResOpenYn: 'A',
    });

    // 검색조건 - 공개 상태 (Y 공개, N 비공개)
    const searchResOpenYn = ref([
        { label:"전체", value: "A" },
        { label:"공개", value: "Y" },
        { label:"비공개", value: "N" },
    ]);

    // 모달
    const userMatchingResumeCreateModal = ref(null);
    const userMatchingResumeModal = ref(null);

    let letUserGb = ''
    let corpMasterYn = ''

    const shouldRender = ref(true);
    const getUserInfo = async () => {
      loadingStore.loading = true;
      const userInStorage = sessionStorage.getItem('user');
      if(userInStorage) {
        const { userGb, userInfo } = JSON.parse(userInStorage)
        letUserGb = userGb
        corpMasterYn = userInfo.corpMasterYn;
      }
      loadingStore.loading = false;
    }

    const isModal = localStorage.getItem('isModalVisible')

    onMounted( async () => {
      retrieveList();

      await getUserInfo()
      if(letUserGb === 'STUDENT') {
        if(isModal === 'true') {
          matchingResumeModal.value.show();
        }
      } else {
        shouldRender.value = false;
        await $alert("학생/취업준비생 회원만 지원 가능합니다.");
        router.go(-2);
      }
    })

    const isInitView = computed(()=> {
        return currentPage.value === 1;
    });

    const retrieveList = () => {

        const interests = _.map(_searchInput.value.searchInterests).join(',');

        let paramObj = {
            pageNumber: currentPage.value,
            size: pageSize,
            searchInterests: interests,
            searchMonths: _searchInput.value.searchMonthType,
            searchResOpenYn: _searchInput.value.searchResOpenYn
        }
        // console.log(paramObj);
        loadingStore.loading = true;
        mypageUserResumeService.retrieveUserMatchingResumeList(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    list.value = $pageListPorpId(result.content, totalCount.value, pageSize, currentPage.value);
                    //console.log(list.value)
                    // 매칭 상태값 업데이트
                    await retrieveMatchingUpdate();
                }
            }).catch( (error) =>  {
                loadingStore.loading = false;
                console.log(error);
            });
    }

    // 매칭 상태값 업데이트 (matchingUpdateStore 업데이트)
    const retrieveMatchingUpdate = async () => {
      await mypageMatchingService.retrieveMatchingUpdate()
          .then( async (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              matchingUpdateStore.matchingUpdate = result;
              await matchingUpdateStore.setMatchingUpdate( result );
              matchingUpdateStore.value = await useMatchingUpdateStore();
              snbKey.value += 1;
            }
          }).catch( (error) => {
            loadingStore.loading = false;
            console.log(error);
          });
    }

    const onSelectedPage = (pageNo) => {
        currentPage.value = pageNo;
        retrieveList();
    }

    // 이력서 보기
    const onClickUserMatchingResumeDetail = (resumeId) => {
        userMatchingResumeModal.value.init(false);
        userMatchingResumeModal.value.retrieveUserMatchingResumeDetail(resumeId, 0);
        userMatchingResumeModal.value.show();
    }

    // 이력서 작성 버튼
    const onClickCreateUserMatchingResume = async () => {

        mypageUserResumeService.retrieveAgreeInfoProvYn()
            .then( (res) => {
                if ( res.data.result.agreeInfoProvYn === "Y" ) {
                    showUserMatchingResumeCreateModal();
                } else {
                    confirmAgreeInfoProvYnChange();
                }
            }).catch( (res) =>  {
            console.log(res);
            $toast('error', '오류가 발생하였습니다.');
        });

    }

    // 제3자 정보 제공 동의처리 의사 확인
    const confirmAgreeInfoProvYnChange = async () => {
        const ok = await $confirm(["개인정보 제공에 동의하나요?", "동의하지 않을 시 이력서 작성 후 전송을 할 수 없습니다."], "동의", "동의하지 않음");
        if ( ok ) { // 동의
            changeAgreeInfoProvYn();
        } else {    // 동의하지 않음

        }
    }

    // 제3자 정보 제공 동의여부 변경
    const changeAgreeInfoProvYn = () => {

        loadingStore.loading = true;

        let paramObj = {
            agreeInfoProvYn: "Y",
        }

        mypageUserResumeService.changeAgreeInfoProvYnState(paramObj)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    //let result = res.data.result;
                    //console.log(result);
                    showUserMatchingResumeCreateModal();
                }
            }).catch( (error) =>  {
            loadingStore.loading = false;
            console.log(error);
        });

    }

    // 이력서 작성 모달 실행
    const showUserMatchingResumeCreateModal = async () => {
        userMatchingResumeCreateModal.value.init();
        await userMatchingResumeCreateModal.value.show();
    }

    // 초기화 버튼
    const clearSearchInput = () => {
      interestGbListRef.value.initOptions()
      _searchInput.value = {
        searchMonthType: '0',
        searchInterests: '설계,장비,소재,제조공정,패키지,테스트,SW,기타',
        searchResOpenYn: 'A',
      };
    }

    // 노출여부 변경
    const onClickChangeResOpenYn = async (resumeId, resOpenYn) => {
        let ok;
        if ( resOpenYn === "Y" ) {
            ok = await $confirm(["인재 노출할까요?", "노출 시 기업 인사 담당자에게 이력서가 노출됩니다."], "노출", "취소");
        } else {
            ok = await $confirm(["인재 노출을 중지할까요?", "중지 시 기업 인사 담당자에게 이력서가 노출되지 않습니다."], "중지", "취소");
        }

        if ( ok ) {
            let paramObj = {
                resumeId: resumeId,
                resOpenYn: resOpenYn
            }

            mypageUserResumeService.changeResOpenYnState(paramObj)
                .then((res) => {
                    loadingStore.loading = false;
                    if (res.data.code.toLowerCase() === 'success') {
                        //let result = res.data.result;
                        //console.log(result);
                        retrieveList();
                    }
                }).catch((error) => {
                loadingStore.loading = false;
                console.log(error);
            });

        }

    }

</script>

<template>
    <div v-if="shouldRender">
      <div class="process-wrap">
        <h4>입사 지원 절차</h4>
        <div class="process-layout">
          <div class="process-steps-scroll">
            <div class="process-steps">
              <div class="step"><div>이력서<br>작성/전송</div></div>
              <div class="step-arrow"><div></div></div>
              <div class="step"><div>인재 정보<br>등록/노출</div></div>
              <div class="step-arrow"><div></div></div>
              <div class="step"><div>채용 제안<br>확인/수락</div></div>
              <div class="step-arrow"><div></div></div>
              <div class="step"><div>매칭 완료</div></div>
              <div class="step-arrow active"><div></div></div>
              <div class="step large active"><div>기업별 채용<br>전형 진행</div></div>
            </div>
          </div>
          <div class="button-with-info">
            <p><em>실시간 인재정보 등록</em>하고<br><strong>상시 채용제안</strong>을 받아보세요.</p>
            <div class="button-with-info-cta" @click="onClickCreateUserMatchingResume">인재정보 등록하기<span class="icon-button-right"></span></div>
          </div>
        </div>
      </div>
      <div class="filter-wrap" :class="{'open': searchOpen}">
        <p @click="searchOpen = !searchOpen">검색</p>
        <div class="filter">
          <dl>
            <dt>이력서 등록일시</dt>
            <dd>
              <div class="grid">
                <template v-for="group in searchMonths">
                  <KSARadioButton class="mr-md" name="searchMonthGb" :label="group.label" v-model="_searchInput.searchMonthType" :value="group.value" />
                </template>
              </div>
            </dd>
          </dl>
          <dl>
            <dt>관심 카테고리</dt>
            <dd>
              <div class="grid">
                <KSACheckBoxGroup
                    ref="interestGbListRef"
                    className="mr-md"
                    name="searchInterests"
                    v-model="_searchInput.searchInterests"
                    :options="data_interests" />
              </div>
            </dd>
          </dl>
          <dl>
            <dt>공개 상태</dt>
            <dd>
              <div class="grid">
                <template v-for="group in searchResOpenYn">
                  <KSARadioButton class="mr-md" name="searchResOpenYnGb" :label="group.label" v-model="_searchInput.searchResOpenYn" :value="group.value" />
                </template>
              </div>
            </dd>
          </dl>
          <div class="btn-wrap">
            <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
            <KSAPrimaryButton text="검색" @click="retrieveList" />
          </div>
        </div>
      </div>
      <div class="list-top">
        <p>총 <span>{{ $number(totalCount) }}</span>건</p>
      </div>
      <div class="table-form board-mobile-vertical">
        <table>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <tr>
            <th>매칭 희망 기업</th>
            <th>이력서</th>
            <th>관심 카테고리</th>
            <th>이력서 등록일시</th>
            <th>인재정보 공개/비공개</th>
          </tr>
          <tr v-for="(proposal) in list">
            <td data-title="매칭 희망 기업 : ">
              <span v-if="proposal.stateCnt > 0" class="red-dot"></span>
              <span @click="router.push({name:'UserMatchingResumeProposalDetail', params:{id:proposal.resumeId}})" class="clickable proposal" style="cursor:pointer">{{ proposal.corpCnt }} 개 기업이 매칭 희망합니다</span>
            </td>
            <td data-title="이력서 : "><KSATextButton class="clickable resume" text="이력서 보기" @click="onClickUserMatchingResumeDetail(proposal.resumeId)" /></td>
            <td data-title="관심 카테고리 : ">{{ proposal.interests }}</td>
            <td data-title="이력서 등록일시 : ">{{ $yyyymmddHHmmss(proposal.createDate)}}</td>
            <td data-title="인재정보 공개/비공개 : ">
              <img v-if="proposal.resOpenYn === 'Y'" src="../../../../../assets/images/toggle_on.png" @click="onClickChangeResOpenYn(proposal.resumeId, 'N')" style="cursor:pointer;" />
              <img v-else src="../../../../../assets/images/toggle_off.png" @click="onClickChangeResOpenYn(proposal.resumeId, 'Y')" style="cursor:pointer;" />
            </td>
          </tr>
        </table>
        <div class="result-none" v-if="list.length === 0">
          전송한 이력서가 없습니다.
        </div>
      </div>
      <Paginate
          v-if="list.length > 0"
          v-model="currentPage"
          :page-count="totalPages"
          :click-handler="onSelectedPage"
      />
    </div>
    <div v-else class="white-background"></div>
    <MatchingResumeModal v-if="isModal" ref="matchingResumeModal" />
    <UserMatchingResumeCreateModal ref="userMatchingResumeCreateModal"/>
    <MyPageResumeModal ref="userMatchingResumeModal"/>
</template>

<style lang="scss" scoped>
    @import "../../../../../assets/scss/theme";

    .clickable {
      cursor: pointer;
      color: #3843AF;
      &.proposal {
        &:hover {
          font-weight: 700;
          // text-decoration: underline;
        }
      }
      &.resume {
        color: #3C72FF;
        &:hover {
          font-weight: 700;
          text-decoration: underline;
        }
      }


    }

    .white-background {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: white;
    }

    .blueTextButton { color: $blue_color; }
</style>